import React from 'react'
import TransferOutForm from '../PureComponents/TransferOutForm';

const RenderTrasferOutForm = () => {
  return <TransferOutForm />;
}

export default RenderTrasferOutForm